import { createUseStyles } from 'react-jss'
import { mediumGrey } from '../../styles/const/colors'

export default createUseStyles(theme => ({
  actionText: {
    display: 'block',
    textAlign: 'center',
    marginTop: 16,
    cursor: 'pointer',
    color: mediumGrey,

    '&:hover': {
      color: theme.brandPrimary
    },

    '&.isTouched': {
      color: theme.brandPrimary
    }
  }
}))
